import { useEffect, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { HeroLeadForm } from "@/components/HeroLeadForm";

const LEAD_FORM_EVENT = "open-lead-form-dialog";

export function openLeadFormDialog() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(LEAD_FORM_EVENT));
}

export function handleLeadFormClick(event: { preventDefault: () => void }) {
  event.preventDefault();
  openLeadFormDialog();
}

const DEFAULT_BADGE = "LIMITED TIME SPECIAL · SEPTEMBER, 2026";

export function LeadFormDialog({
  heading = "Back to School. Back to Business.",
  badge = DEFAULT_BADGE,
}: {
  heading?: string;
  badge?: string;
} = {}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(LEAD_FORM_EVENT, handler);
    return () => window.removeEventListener(LEAD_FORM_EVENT, handler);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <div className="inline-flex w-fit items-center rounded-full bg-primary px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-primary-foreground">
            {badge}
          </div>
          <DialogTitle className="text-left text-2xl font-bold">
            {heading}
          </DialogTitle>
          <DialogDescription className="text-left">
            Get in touch with us below, and our founder will arrange a call with you to learn
            more about your goals.
          </DialogDescription>
        </DialogHeader>
        <HeroLeadForm idPrefix="dialog" />
      </DialogContent>
    </Dialog>
  );
}
